import cache from './cache.js';
import getOperatingSystem from './getOperatingSystem.js';

export default cache('isKindleFire', function isKindleFire() {
  return getOperatingSystem().name.includes('Fire OS');
});